module.exports = __webpack_public_path__ + "img/f-2_mob.4fdfd986.jpg";